"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _functions = require("../../../util/functions");

require("./PerformanceRow.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var CumPerfRow =
/*#__PURE__*/
function (_Component) {
  _inherits(CumPerfRow, _Component);

  function CumPerfRow() {
    _classCallCheck(this, CumPerfRow);

    return _possibleConstructorReturn(this, _getPrototypeOf(CumPerfRow).apply(this, arguments));
  }

  _createClass(CumPerfRow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          fund = _this$props.fund,
          showCommonPeriod = _this$props.showCommonPeriod,
          isPortfolio = _this$props.isPortfolio;

      if (fund.stdPerformance === null) {
        return null;
      }

      var url = fund.fundPageURL ? fund.fundPageURL : 'http://performance.morningstar.com/fund/performance-return.action?t=' + fund.ticker;
      var hide = fund.type === 'BMK' ^ fund.type === 'MF' ^ isPortfolio;
      var yearStart = new Date(new Date().getFullYear(), 0, 1);
      var yearStartISO = yearStart.toISOString();
      var hideYTD = yearStartISO <= this.props.fund.inceptionDate ? true : false;
      var stdPerformance = Array.isArray(fund.stdPerformance) ? fund.stdPerformance[0] : fund.stdPerformance;
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement("tr", {
        className: this.props.index === 0 ? 'whiteline' : 'greyline',
        key: Math.random()
      }, !isPortfolio ? _react.default.createElement("td", {
        width: "50",
        className: "textLeft"
      }, _react.default.createElement("a", {
        className: "tickerLink",
        href: url,
        target: "_new"
      }, fund.ticker)) : null, fund.type === 'BMK' ^ isPortfolio ? _react.default.createElement("td", {
        width: "300",
        className: "textLeft row-name"
      }, fund.name.replace(/&amp;/g, '&')) : _react.default.createElement("td", {
        width: "300",
        className: "textLeft row-name"
      }, fund.name.replace(/&amp;/g, '&') + ' (NAV)'), _react.default.createElement("td", {
        className: "textCenter"
      }, (0, _functions.formatPercent)(stdPerformance.mtdNAV)), _react.default.createElement("td", {
        className: "textCenter"
      }, (0, _functions.formatPercent)(stdPerformance.mos3NAV)), _react.default.createElement("td", {
        className: "textCenter"
      }, hideYTD === true ? '-' : (0, _functions.formatPercent)(stdPerformance.ytdNAV)), _react.default.createElement("td", {
        className: "textCenter"
      }, (0, _functions.formatPercent)(stdPerformance.yrs1NAV)), _react.default.createElement("td", {
        className: "textCenter"
      }, (0, _functions.formatPercent)(stdPerformance.yrs3NAV)), _react.default.createElement("td", {
        className: "textCenter"
      }, (0, _functions.formatPercent)(stdPerformance.yrs5NAV)), _react.default.createElement("td", {
        className: "textCenter"
      }, (0, _functions.formatPercent)(stdPerformance.yrs10NAV)), fund.type === 'BMK' ? _react.default.createElement("td", {
        className: "textCenter"
      }, "-") : _react.default.createElement("td", {
        className: "textCenter"
      }, (0, _functions.formatPercent)(stdPerformance.inceptionNAV)), showCommonPeriod ? _react.default.createElement("td", {
        className: "textCenter"
      }, (0, _functions.formatPercent)(stdPerformance.commonPeriodNAV)) : null), !hide && _react.default.createElement("tr", {
        className: "whiteline",
        key: Math.random()
      }, _react.default.createElement("td", {
        width: "50",
        className: "textLeft"
      }, "\xA0"), _react.default.createElement("td", {
        width: "350",
        className: "textLeft row-name"
      }, fund.name.replace(/&amp;/g, '&') + ' (MP)'), _react.default.createElement("td", {
        className: "textCenter"
      }, (0, _functions.formatPercent)(stdPerformance.mtdMP)), _react.default.createElement("td", {
        className: "textCenter"
      }, (0, _functions.formatPercent)(stdPerformance.mos3MP)), _react.default.createElement("td", {
        className: "textCenter"
      }, hideYTD === true ? '-' : (0, _functions.formatPercent)(stdPerformance.ytdMP)), _react.default.createElement("td", {
        className: "textCenter"
      }, (0, _functions.formatPercent)(stdPerformance.yrs1MP)), _react.default.createElement("td", {
        className: "textCenter"
      }, (0, _functions.formatPercent)(stdPerformance.yrs3MP)), _react.default.createElement("td", {
        className: "textCenter"
      }, (0, _functions.formatPercent)(stdPerformance.yrs5MP)), _react.default.createElement("td", {
        className: "textCenter"
      }, (0, _functions.formatPercent)(stdPerformance.yrs10MP)), _react.default.createElement("td", {
        className: "textCenter"
      }, (0, _functions.formatPercent)(stdPerformance.inceptionMP)), showCommonPeriod ? _react.default.createElement("td", {
        className: "textCenter"
      }, (0, _functions.formatPercent)(stdPerformance.commonPeriodMP)) : null));
    }
  }]);

  return CumPerfRow;
}(_react.Component);

_defineProperty(CumPerfRow, "defaultProps", {
  showCommonPeriod: true,
  isPortfolio: false
});

CumPerfRow.propTypes = {
  /**
   * Show the common period returns
   */
  showCommonPeriod: _propTypes.default.bool,

  /**
   * Indicate if the table is portfolio level
   */
  isPortfolio: _propTypes.default.bool,

  /**
   * Index of row
   */
  index: _propTypes.default.number
};
var _default = CumPerfRow;
exports.default = _default;